import React, { useState, useEffect } from 'react';
import { Redirect, Link } from 'react-router-dom';


import 'react-accessible-accordion/dist/fancy-example.css';

import DataTable from 'react-data-table-component';

import { reqGET } from '../../../Utils';
import { api_crud_base, api_crud_route, data_interface, endpoints } from './Config';
import { getTokenInfo } from './../../../UseToken';

export default function View(props) {

    const [dados, set_dados] = useState(data_interface);

    const [isloading, setLoading] = useState(true);
    const [isRedirect, setRedirect] = useState(false);

    //const [hidePessoal, set_hide_pessoal] = useState('')
    const [hideEmpresarial, set_hide_empresarial] = useState('')

    const [data_creditos, set_credits] = useState([]);
    const [activeTab, setActiveTab] = useState('addresses');
    const [expandedDept, setExpandedDept] = useState(null);
    const [showModal, setShowModal] = useState(false);
    const [modalContent, setModalContent] = useState({});
    const [responsaveisPorDepartamento, setResponsaveisPorDepartamento] = useState([]);
    const [projetoAtual, setProjetoAtual] = useState(null);
    const [responsavelInputNome, setresponsavelInputNome] = useState('');
    const [responsavelInputTel, setresponsavelInputTel] = useState('');
    const [departamentoSelecionado, setDepartamentoSelecionado] = useState('');
    const [departamentoid, setDepartamentoId] = useState();
    const [isProjectModalOpen, setIsProjectModalOpen] = useState(false);
    const [codProjetoInput, setCodProjetoInput] = useState('');
    const [tipoIdInput, setTipoIdInput] = useState(1); // Inicializa com o primeiro tipo
    const [linhaIdInput, setLinhaIdInput] = useState(1); // Inicializa com a primeira linha
    const [nLicencaInput, setNLicencaInput] = useState('');
    const [dataInicioInput, setDataInicioInput] = useState('');
    const [dataFimInput, setDataFimInput] = useState('');
    const [assistenciaRemotaInput, setAssistenciaRemotaInput] = useState(false);
    const [tempoAssistenciaInput, setTempoAssistenciaInput] = useState('');
    const [assistenciaPermitidaInput, setAssistenciaPermitidaInput] = useState(false);



    const columns_creditos = [
        {
            name: <div className="table-header">Proposta</div>,
            sortable: true,
            maxWidth: '100px',
            selector: 'proposta',
            left: true,
        },
        {
            name: <div className="table-header">Escritório</div>,
            selector: 'escritorio',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Responsável</div>,
            selector: 'responsavel',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Promotor</div>,
            selector: 'promotor',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Tipo de Crédito</div>,
            selector: 'tipo_credito',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Valor Financiado</div>,
            cell: row => <div>{row.valor_financiado}€</div>,
            maxWidth: '150px',
            sortable: true,
            left: true,
        },
        {
            name: <div className="table-header">Estado</div>,
            cell: row => 'Saber mais +',
            maxWidth: '150px',
            left: true,
        },
    ];

    //const ExpandableComponent = ({ data }) => <span>###{data.proposta}###</span>;
    const ExpandableComponent = ({ data }) =>
        <div className="div-expand">
            <div dangerouslySetInnerHTML={{ __html: data.timeline }} />
        </div>;

    const defaultComponentOptions = {
        rowsPerPageText: 'Registos por página:',
        rangeSeparatorText: 'de',
        noRowsPerPage: false,
        selectAllRowsItem: false,
        selectAllRowsItemText: 'Todos',
        responsive: true,
    };

    const EditProjeto = (codProjeto) => {
        const projeto = dados.current.info.projetos.find(proj => proj.codProjeto === codProjeto);
        if (projeto) {
            setProjetoAtual(projeto); // Armazena o projeto atual para edição
            setCodProjetoInput(projeto.codProjeto);
            setTipoIdInput(projeto.nome[0].tipo.id);
            setLinhaIdInput(projeto.nome[0].linha.id);
            setNLicencaInput(projeto.nLicenca);
            setDataInicioInput(projeto.dataInicio);
            setDataFimInput(projeto.dataFim);
            setAssistenciaRemotaInput(projeto.assistenciaRemota);
            setTempoAssistenciaInput(projeto.tempoAssistencia);
            setAssistenciaPermitidaInput(projeto.assistenciaPermitida);
            setIsProjectModalOpen(true); // Abre o modal para edição
        } else {
            console.log("Projeto não encontrado");
        }
    };


    const DeleteProjeto = (codProjeto) => {
        const index = dados.current.info.projetos.findIndex(projeto => projeto.codProjeto === codProjeto);

        if (index !== -1) {
            dados.current.info.projetos.splice(index, 1);
            console.log("Projeto Apagado:", codProjeto);
        } else {
            console.log("Projeto não encontrado:", codProjeto);
        }
    }
    const load_credits = async (id) => {

        reqGET(`${api_crud_base}/credits/credits/special/credits/Promotor/${getTokenInfo().companycode}/${id}`)
            .then(res => {
                //console.log(res.data)
                set_credits(...[
                    res.data.map(k => {
                        let aux_estado = '';
                        let aux_timeline = '<div><ul class="timeline">';
                        var i = 0;
                        if (k.info.estado)
                            k.info.estado.forEach((v_1) => {

                                i++;
                                var j = 0;
                                v_1.etapas.forEach((v_2) => {
                                    if (i === 5) {
                                        i = 1;
                                        aux_timeline = aux_timeline + '</ul><ul class="timeline">';
                                    }

                                    if (v_1.data.localeCompare("") !== 0) {
                                        if (v_2.activo) {
                                            if (v_2.value.localeCompare(v_2.sucesso.id) === 0) {
                                                aux_timeline = aux_timeline + '<li class="completed">'
                                                    + '<div class="timestamp">'
                                                    + '<span class="author"></span>'
                                                    + '<span class="date"></span>'
                                                    + '</div>'
                                                    + '<div class="status">'
                                                    + '<h4>' + v_1.label + '</h4>'
                                                    + '</div>'
                                                    + '<div class="on-course">'
                                                    + '<h4 class="on-course">em curso</h4>'
                                                    + '</div>'
                                                    + '</li>';
                                            }
                                            else if (v_2.value.localeCompare(v_2.insucesso.id) === 0) {
                                                aux_estado = 'Cancelado';
                                                aux_timeline = aux_timeline + '<li class="error">'
                                                    + '<div class="timestamp">'
                                                    + '<span class="author"></span>'
                                                    + '<span class="date"></span>'
                                                    + '</div>'
                                                    + '<div class="status">'
                                                    + '<h4>' + v_1.label + '</h4>'
                                                    + '</div>'
                                                    + '<div class="on-course">'
                                                    + '<h4 class="on-course">em curso</h4>'
                                                    + '</div>'
                                                    + '</li>';

                                            }
                                            else {
                                                aux_estado = v_1.label;
                                                aux_timeline = aux_timeline + '<li class="on-course">'
                                                    + '<div class="timestamp">'
                                                    + '<span class="author"></span>'
                                                    + '<span class="date"></span>'
                                                    + '</div>'
                                                    + '<div class="status">'
                                                    + '<h4>' + v_1.label + '</h4>'
                                                    + '</div>'
                                                    + '<div class="on-course">'
                                                    + '<h4 class="on-course">em curso</h4>'
                                                    + '</div>'
                                                    + '</li>';
                                            }
                                        }
                                    }
                                    else {
                                        if (j === 0) {
                                            j++;
                                            aux_timeline = aux_timeline + '<li class="">'
                                                + '<div class="timestamp">'
                                                + '<span class="author"></span>'
                                                + '<span class="date"></span>'
                                                + '</div>'
                                                + '<div class="status">'
                                                + '<h4>' + v_1.label + '</h4>'
                                                + '</div>'
                                                + '<div class="on-course">'
                                                + '<h4 class="on-course">em curso</h4>'
                                                + '</div>'
                                                + '</li>';
                                        }
                                    }

                                })

                            });
                        if (k.info.workflow)
                            k.info.workflow.forEach((v_1) => {
                                i++;
                                var j = 0;
                                if (v_1.estado)
                                    v_1.estado.forEach((v_2) => {
                                        if (i === 5) {
                                            i = 1;
                                            aux_timeline = aux_timeline + '</ul><ul class="timeline">';
                                        }

                                        if (v_1.data.localeCompare("") !== 0) {
                                            if (v_2.selected) {
                                                //console.log(v_2.selected)
                                                if (v_2.pendente === false && v_2.completo === true) {
                                                    aux_timeline = aux_timeline + '<li class="completed">'
                                                        + '<div class="timestamp">'
                                                        + '<span class="author"></span>'
                                                        + '<span class="date"></span>'
                                                        + '</div>'
                                                        + '<div class="status">'
                                                        + '<h4>' + v_1.name + '</h4>'
                                                        + '</div>'
                                                        + '<div class="on-course">'
                                                        + '<h4 class="on-course">em curso</h4>'
                                                        + '</div>'
                                                        + '</li>';
                                                }
                                                else if (0) {
                                                    aux_estado = 'Cancelado';
                                                    aux_timeline = aux_timeline + '<li class="error">'
                                                        + '<div class="timestamp">'
                                                        + '<span class="author"></span>'
                                                        + '<span class="date"></span>'
                                                        + '</div>'
                                                        + '<div class="status">'
                                                        + '<h4>' + v_1.name + '</h4>'
                                                        + '</div>'
                                                        + '<div class="on-course">'
                                                        + '<h4 class="on-course">em curso</h4>'
                                                        + '</div>'
                                                        + '</li>';

                                                }
                                                else {
                                                    aux_estado = v_1.label;
                                                    aux_timeline = aux_timeline + '<li class="on-course">'
                                                        + '<div class="timestamp">'
                                                        + '<span class="author"></span>'
                                                        + '<span class="date"></span>'
                                                        + '</div>'
                                                        + '<div class="status">'
                                                        + '<h4>' + v_1.name + '</h4>'
                                                        + '</div>'
                                                        + '<div class="on-course">'
                                                        + '<h4 class="on-course">em curso</h4>'
                                                        + '</div>'
                                                        + '</li>';
                                                }
                                            }
                                        }
                                        else {
                                            if (j === 0) {
                                                j++;
                                                aux_timeline = aux_timeline + '<li class="">'
                                                    + '<div class="timestamp">'
                                                    + '<span class="author"></span>'
                                                    + '<span class="date"></span>'
                                                    + '</div>'
                                                    + '<div class="status">'
                                                    + '<h4>' + v_1.name + '</h4>'
                                                    + '</div>'
                                                    + '<div class="on-course">'
                                                    + '<h4 class="on-course">em curso</h4>'
                                                    + '</div>'
                                                    + '</li>';
                                            }
                                        }

                                    })

                            });
                        aux_timeline += '</ul></div>';

                        return {
                            proposta: k['id'],
                            escritorio: k.info.escritorio['name'],
                            responsavel: k.info.responsavel['name'],
                            promotor: k.info.promotor['name'],
                            tipo_credito: k.info.tipo_credito['name'],
                            valor_financiado: k.commissioning['valor_financiado'],
                            estado: aux_estado,
                            timeline: aux_timeline
                        }

                    })
                ])
                //console.log(credits)
            })
    }




    // Para Instanciar todo o Objecto 
    const fetchInfo = async (id) => {
        await reqGET(`${api_crud_route}/${getTokenInfo().companycode}/${id}`)
            .then(res => {
                set_dados(res.data[0]);

                console.log(res.data[0])

            })
            .catch(() => 404
                //  TODO: ENVIAR PÝGINA 404
                //  alert(error)); 
            );
    }


    const handleModalShow = (responsaveis) => {
        console.log(responsaveis)
        setModalContent(responsaveis); // Define os responsáveis no modal
        setShowModal(true); // Abre o modal
    };



    const handleModalClose = () => {
        setShowModal(false);
        setModalContent([]);
    };

    useEffect(() => {

        if (props.location.state !== undefined) {

            fetchInfo(props.location.state.item['id']).then(() => setLoading(false))
        }
        else {
            setLoading(false);
            setRedirect(true);
        }






    }, [props]);

    useEffect(() => {
        console.log("Current expandedDept state:", expandedDept);
    }, [expandedDept]);

    // Defina a função toggleExpand fora do useEffect


    return isRedirect ?
        <Redirect to={endpoints.list} replace />
        :
        isloading ?
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">LOADING</h2>
                    <p>LOADING</p>
                    <div className="overlay">
                        <div className="overlay__inner">
                            <div className="overlay__content"><span className="spinner"></span></div>
                        </div>
                    </div>
                </div>
            </main>
            :
            <main>
                <div className={`dash-cards-2 header`}>
                    <h2 className="dash-title">Empresa01</h2>
                    <p>Home / Empresa01 / </p>
                </div>

                <div style={{ maxWidth: '900px', margin: '0 auto', padding: '20px' }}>
                    <div style={{
                        backgroundColor: '#fff',
                        borderRadius: '8px',
                        boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                        marginBottom: '20px'
                    }}>
                        <div style={{
                            padding: '15px',
                            backgroundColor: '#007bff',
                            color: '#fff',
                            borderRadius: '8px 8px 0 0'
                        }}>
                            <h3>Detalhes da Empresa</h3>
                        </div>
                        <div style={{ padding: '15px' }}>
                            <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                <div style={{ flex: '0 0 48%' }}>
                                    <p><strong>Nome:</strong> {dados.info.name}</p>
                                    <p><strong>Tipo de Entidade:</strong> {dados.info.entity_type}</p>
                                    <p><strong>Código da Empresa:</strong> {dados.info.companycode}</p>
                                </div>
                                <div style={{ flex: '0 0 48%' }}>
                                    <p><strong>NIF:</strong> {dados.info.vat}</p>
                                    <p><strong>Validade da Identificação:</strong> {dados.info.identificacao.validade_identificacao}</p>
                                    <p><strong>Observações:</strong> {dados.info.observation}</p>
                                </div>
                            </div>
                        </div>
                    </div>

                    <div style={{ display: 'flex', marginBottom: '20px' }}>
                        <button
                            style={{
                                flex: 1,
                                padding: '10px 20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: activeTab === 'addresses' ? '#007bff' : '#f0f0f0',
                                color: activeTab === 'addresses' ? '#fff' : '#000',
                                border: '1px solid #ddd',
                                borderBottom: 'none'
                            }}
                            onClick={() => setActiveTab('addresses')}
                        >
                            Endereços
                        </button>
                        <button
                            style={{
                                flex: 1,
                                padding: '10px 20px',
                                textAlign: 'center',
                                cursor: 'pointer',
                                backgroundColor: activeTab === 'contacts' ? '#007bff' : '#f0f0f0',
                                color: activeTab === 'contacts' ? '#fff' : '#000',
                                border: '1px solid #ddd',
                                borderBottom: 'none'
                            }}
                            onClick={() => setActiveTab('contacts')}
                        >
                            Contatos
                        </button>
                    </div>

                    {activeTab === 'addresses' && (
                        <div style={{ padding: '15px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '0 0 8px 8px' }}>
                            {dados.addresses.map((address, index) => (
                                <div style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    marginBottom: '20px'
                                }} key={index}>
                                    <div style={{ padding: '15px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            <div style={{ flex: '0 0 48%' }}>
                                                <p><strong>Vila:</strong> {address.village}</p>
                                                <p><strong>Cidade:</strong> {address.city}</p>
                                                <p><strong>Região:</strong> {address.region}</p>
                                                <p><strong>País:</strong> {address.country}</p>
                                            </div>
                                            <div style={{ flex: '0 0 48%' }}>
                                                <p><strong>Rua:</strong> {address.street_name}, {address.address_detail}</p>
                                                <p><strong>Código Postal:</strong> {address.postal_code}</p>
                                                <p><strong>Tipo:</strong> {address.type.join(', ')}</p>
                                                <p><strong>Observações:</strong> {address.observation}</p>
                                            </div>
                                        </div>
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}

                    {activeTab === 'contacts' && (
                        <div style={{ padding: '15px', backgroundColor: '#fff', border: '1px solid #ddd', borderRadius: '0 0 8px 8px' }}>
                            {dados.contacts.map((contact, index) => (

                                <div style={{
                                    backgroundColor: '#fff',
                                    borderRadius: '8px',
                                    boxShadow: '0 4px 8px rgba(0, 0, 0, 0.1)',
                                    marginBottom: '20px'
                                }} key={index}>
                                    <div style={{ padding: '15px' }}>
                                        <div style={{ display: 'flex', justifyContent: 'space-between', marginBottom: '10px' }}>
                                            {console.log("array:", contact)}
                                            <div style={{ flex: '0 0 48%' }}>
                                                <p><strong>Email:</strong> {contact.email}</p>
                                                <p><strong>Telefone:</strong> {contact.phone}</p>
                                                <p><strong>Telemóvel:</strong> {contact.mobile_phone}</p>
                                            </div>
                                            <div style={{ flex: '0 0 48%' }}>
                                                <p><strong>Número do Edifício:</strong> {contact.building_number}</p>
                                                <p><strong>Extensões:</strong> {contact.extensions.join(', ')}</p>
                                                <p><strong>Observações:</strong> {contact.observation}</p>
                                            </div>
                                        </div>

                                        <h4 style={{ marginTop: '20px' }}>Departamentos</h4>
                                        {contact.departamentos.map((departamento) => (
                                            <div key={departamento.id}>
                                                <button
                                                    style={{
                                                        display: 'block',
                                                        width: '100%',
                                                        textAlign: 'left',
                                                        padding: '10px',
                                                        marginTop: '10px',
                                                        backgroundColor: '#f9f9f9',
                                                        border: '1px solid #ddd',
                                                        cursor: 'pointer'
                                                    }}
                                                    onClick={() => {

                                                        // Filtrar responsáveis para o departamento selecionado
                                                        const responsaveis = contact.person_responsables.filter(responsavel =>
                                                            responsavel.departamentos &&
                                                            responsavel.departamentos.includes(departamento.id)
                                                        );
                                                        // Abrir o modal e passar os responsáveis filtrados
                                                        handleModalShow(responsaveis);
                                                    }}
                                                >
                                                    {departamento.nome}



                                                </button>
                                            </div>
                                        ))}
                                    </div>
                                </div>
                            ))}
                        </div>
                    )}
                    <div className="col-md-8">
                        <h5>Projetos:</h5>
                        {dados.current && dados.current.info && Array.isArray(dados.current.info.projetos) && dados.current.info.projetos.length > 0 ? (
                            <table className="table table-bordered">
                                <thead>
                                    <tr>
                                        <th scope="col">Tipo</th>
                                        <th scope="col">Linha</th>
                                        <th scope="col">Ações</th>
                                    </tr>
                                </thead>
                                <tbody>
                                    {dados.current.info.projetos.map((projeto) => (
                                        <tr key={projeto.codProjeto}>
                                            <td>
                                                {projeto.nome && projeto.nome[0] && projeto.nome[0].tipo && projeto.nome[0].linha
                                                    ? projeto.nome[0].tipo.nome
                                                    : 'Tipo Indisponível'}
                                            </td>
                                            <td>
                                                {projeto.nome && projeto.nome[0] && projeto.nome[0].linha
                                                    ? projeto.nome[0].linha.nome
                                                    : 'Linha Indisponível'}
                                            </td>
                                            <td>
                                                <button
                                                    type="button"
                                                    className="btn btn-primary btn-sm"
                                                    onClick={() => EditProjeto(projeto.codProjeto)}
                                                    aria-label={`Editar o projeto ${projeto.codProjeto}`}
                                                >
                                                    Editar
                                                </button>
                                                {' '}
                                                <button
                                                    type="button"
                                                    className="btn btn-danger btn-sm"
                                                    onClick={() => {
                                                        if (window.confirm('Tem certeza que deseja apagar este projeto?')) {
                                                            DeleteProjeto(projeto.codProjeto);
                                                        }
                                                    }}
                                                    aria-label={`Apagar o projeto ${projeto.codProjeto}`}
                                                >
                                                    Apagar
                                                </button>
                                            </td>
                                        </tr>
                                    ))}
                                </tbody>
                            </table>
                        ) : (
                            <p>Nenhum projeto disponível</p>
                        )}
                    </div>


                    {showModal && (
                        <div style={{
                            position: 'fixed',
                            top: '0',
                            left: '0',
                            width: '100%',
                            height: '100%',
                            background: 'rgba(0, 0, 0, 0.5)',
                            display: 'flex',
                            justifyContent: 'center',
                            alignItems: 'center'
                        }}>
                            <div style={{
                                background: '#fff',
                                padding: '20px',
                                borderRadius: '8px',
                                width: '400px'
                            }}>
                                <div style={{
                                    display: 'flex',
                                    justifyContent: 'space-between',
                                    alignItems: 'center',
                                    marginBottom: '10px'
                                }}>
                                    <h4>Detalhes do Responsável</h4>
                                    <button
                                        style={{
                                            backgroundColor: '#dc3545',
                                            color: '#fff',
                                            border: 'none',
                                            padding: '5px 10px',
                                            cursor: 'pointer',
                                            borderRadius: '5px'
                                        }}
                                        onClick={handleModalClose}
                                    >
                                        Fechar
                                    </button>
                                </div>
                                {modalContent.length > 0 ? (
                                    modalContent.map(responsavel => (
                                        <div key={responsavel.id} style={{ marginBottom: '10px' }}>
                                            <p><strong>Nome:</strong> {responsavel.nome}</p>
                                            <p><strong>Telemóvel:</strong> {responsavel.tel}</p>
                                        </div>
                                    ))
                                ) : (
                                    <p>Nenhum responsável encontrado para este departamento.</p>
                                )}
                            </div>
                        </div>
                    )}
                </div>

                <div className={'dash-cards-2 footer'}>
                    <nav className="navbar bottom-navbar navbar-light">
                        <div className="navbar-footer">
                            <ul className="navbar-nav float-left"></ul>
                            <ul className="navbar-nav float-right">
                                <li className="nav-item">
                                    <Link className="nav-link btn-cancel" to={{ pathname: endpoints.list }} replace>
                                        <img alt='' src={'./img/seta_2.svg'} />
                                        <span>Voltar</span>
                                    </Link>
                                </li>

                            </ul>
                        </div>
                    </nav>
                </div>
            </main>
}